import React, { Component } from 'react';
import Keycloak from 'keycloak-js';
import md5 from 'js-md5';

class Admin extends Component {
	constructor() {
		super();
		this.state = ({
			keycloak: {},
			user: {
				image: './media/user.png',
				name: 'sam'
			},
			logo: 'logo'
		})
	}
	componentWillMount() {
		const kc = Keycloak(process.env.REACT_APP_KEYCLOAK_JSON_FILE);
		
		kc.init({ onLoad: 'login-required' })
			.success((authenticated) => {
				if (authenticated) {
					this.setState({ keycloak: kc })
					this.state.keycloak.loadUserInfo()
						.success((user) => {
							// if ('adamcrow63+1@gmail.com'.includes("+")) {
							// 	var n = 'adamcrow63+1@gmail.com'.indexOf('+');
							// 	var at = 'adamcrow63+1@gmail.com'.indexOf('@');
							// 	var email = 'adamcrow63+1@gmail.com'.substr(0, n) + 'adamcrow63+1@gmail.com'.substr(at);
							// 	alert(email);
							// }
							md5(user.email);
							//md5('adamcrow63@gmail.com');
							const hash = md5.create();
							//hash.update('adamcrow63@gmail.com');
							hash.update(user.email);
							hash.hex();
							const imgUrl = 'https://www.gravatar.com/avatar/' + hash;
							//alert(imgUrl);
							this.setState({ logo: kc.realm, user: { image: imgUrl, name: user.given_name } })
						});
				}
				else {
					console.log("user could not authenticated");
				}

			})
			.error(function (err) {
				console.log('failed to initialize');

			})
	}

	render() {
		//var { keycloak, user, logo } = this.state;
		return (
			<div>
				<h1 className="text-center">hello admin</h1>
			</div>
		);
	}
}

export default Admin;




// WEBPACK FOOTER //
// ./src/ui/pages/Admin.js